/**
 * Normaliza teléfonos mexicanos escritos como la gente realmente los escribe:
 * "55 1234 5678", "(55) 1234-5678", "+52 55 1234 5678", "+52 1 55 1234 5678".
 *
 * Se normaliza **antes** de validar para no rechazar un número correcto por su formato.
 */
const NATIONAL_LENGTH = 10;

/**
 * Prefijos de marcación que la gente sigue escribiendo, aunque hayan quedado en desuso:
 * "52" internacional, "521"/"044"/"045" heredados de la marcación a móviles y "01" de larga
 * distancia nacional. Se listan del más largo al más corto para no recortar de menos.
 */
const DIALING_PREFIXES = ['521', '045', '044', '52', '01'];

export const PhoneNormalizer = {
  /** Devuelve los 10 dígitos nacionales, o `null` si el texto no puede serlo. */
  normalize(raw: string): string | null {
    const digits = raw.replace(/\D/g, '');
    if (digits.length === NATIONAL_LENGTH) return digits;

    // Solo se recorta si al quitar el prefijo queda exactamente un número nacional: así
    // "5512345678" (que empieza por "55") nunca se confunde con un prefijo.
    const prefix = DIALING_PREFIXES.find(
      (candidate) => digits.length === NATIONAL_LENGTH + candidate.length && digits.startsWith(candidate),
    );
    return prefix ? digits.slice(prefix.length) : null;
  },

  isValid(raw: string): boolean {
    return PhoneNormalizer.normalize(raw) !== null;
  },

  /** Formato de presentación: "55 1234 5678". Devuelve el original si no se puede normalizar. */
  format(raw: string): string {
    const n = PhoneNormalizer.normalize(raw);
    if (!n) return raw;
    return `${n.slice(0, 2)} ${n.slice(2, 6)} ${n.slice(6)}`;
  },
};
